import { render, staticRenderFns } from "./EditGrade.vue?vue&type=template&id=575625da&scoped=true"
import script from "./EditGrade.vue?vue&type=script&lang=js"
export * from "./EditGrade.vue?vue&type=script&lang=js"
import style0 from "./EditGrade.vue?vue&type=style&index=0&id=575625da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575625da",
  null
  
)

export default component.exports